/**
 * Ticket Detail Tabs Barrel Export
 * Centralized export point for all ticket detail tab components
 */
export { TicketDetailsTab } from "./TicketDetailsTab";
export { TicketUpdatesTab } from "./TicketUpdatesTab";
export { ContactDetailsTab } from "./ContactDetailsTab";
export { TicketCompanyDisplay } from "./TicketCompanyDisplay";
export { TimeEntriesTab } from "./TimeEntriesTab";
export { TicketActivityTimelineTab } from "./TicketActivityTimelineTab";
export { TicketAttachmentsTab } from "./TicketAttachmentsTab";
export { TicketTasksTab } from "./TicketTasksTab";
